import React from "react";
import { useNavigate } from "react-router-dom";
import { PLAYER_HEADSHOT_FALLBACK } from "../../../config/constants";
import styles from "./player-pin.module.css";

export function PlayerPin(props) {
  const { player, headshotUrl, isStarter, interactive = true } = props;
  const navigate = useNavigate();

  const card = (
    <div className={`${styles.card} ${isStarter ? styles.starter : ""}`}>
      <img
        src={headshotUrl || PLAYER_HEADSHOT_FALLBACK}
        alt={player.name}
        className={styles.headshot}
        onError={(e) => { e.currentTarget.src = PLAYER_HEADSHOT_FALLBACK; }}
      />
      <div className={styles.info}>
        <div className={styles.name}>{player.name}</div>
        <div className={styles.games}>{player.games}G</div>
      </div>
    </div>
  );

  if (!interactive) return card;

  return (
    <button className={styles.button} onClick={() => navigate(`/player/${player.id}`)}>
      {card}
    </button>
  );
}
